// extracted by mini-css-extract-plugin
export const actionLinks = "MoneyflowTracker__actionLinks__hTGGO";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const danger = "MoneyflowTracker__danger__0e-Ot";
export const emphasis = "MoneyflowTracker__emphasis__ZCxtA";
export const expanded = "MoneyflowTracker__expanded__yJF4Z";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const linkWrapper = "MoneyflowTracker__linkWrapper__lwv6r";
export const medium = "500";
export const moneyflowTracker = "MoneyflowTracker__moneyflowTracker__ZjrFg";
export const moneyflowTrackerInner = "MoneyflowTracker__moneyflowTrackerInner__mDPpm";
export const name = "MoneyflowTracker__name__20XYk";
export const nameWrapper = "MoneyflowTracker__nameWrapper__aAu3h Breakdown__nameWrapper__lE60L";
export const onTrack = "MoneyflowTracker__onTrack__DICwf";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const text = "MoneyflowTracker__text__1E3jK";
export const tracker = "MoneyflowTracker__tracker__L+cdD";
export const trackerDetails = "MoneyflowTracker__trackerDetails__FG0vb";
export const trackerIcon = "MoneyflowTracker__trackerIcon__hDfSJ";
export const trackerInner = "MoneyflowTracker__trackerInner__dwSlc";
export const value = "MoneyflowTracker__value__8FaHL";
export const warning = "MoneyflowTracker__warning__+Q24S";